import { ModalService } from 'pf-frontend-common/src/service/modal/service';

import { MyAccountConfirmationTemplate } from 'common/module/my-account/confirmation/template';
import { MyAccountConfirmationViewStoreFactory } from 'common/module/my-account/confirmation/view-store.factory';
import { MyAccountPopupView } from 'common/module/my-account/popup/view';
import { PreactView } from 'common/module/preact/view';

export function MyAccountPopupViewFactory(): MyAccountPopupView {
  return new MyAccountPopupView(
    ModalService(),
    new PreactView(MyAccountConfirmationTemplate, MyAccountConfirmationViewStoreFactory())
  );
}
